import { Container } from "react-bootstrap";
import { ReferralDashboardProvider, usePermissions, useProfile } from "../../contexts";
import { Claims, UserTypes } from "../../models";
import { LoadingSpinner } from "../../component-library";
import {
    AdminDashboard,
    DistributionDashboard,
    InvoicingDashboard,
    LabDashboard,
    MedicalChartDashboard,
    ProcessingDashboard,
    QualityAssuranceDashboard,
    RecoveryDashboard,
    ReferralDashboard,
    SurgeryDashboard,
} from "..";

export function Dashboard() {
    const { hasRole, hasAnyRole, hasSuperAdminAccess, hasPermission } = usePermissions();
    const { userIsLoading } = useProfile();

    if (userIsLoading) return <LoadingSpinner />;

    if (hasSuperAdminAccess) return <AdminDashboard />;

    if (hasAnyRole([UserTypes.ReferralLead, UserTypes.ReferralCoordinator]))
        return (
            <ReferralDashboardProvider>
                <ReferralDashboard />
            </ReferralDashboardProvider>
        );

    if (hasAnyRole([UserTypes.LabLead, UserTypes.LabCoordinator])) return <LabDashboard />;

    if (hasAnyRole([UserTypes.MedicalChartLead, UserTypes.MedicalChartCoordinator])) return <MedicalChartDashboard />;

    if (hasAnyRole([UserTypes.DistributionLead, UserTypes.DistributionCoordinator])) return <DistributionDashboard />;

    if (hasAnyRole([UserTypes.ProcessingLead, UserTypes.ProcessingCoordinator])) return <ProcessingDashboard />;

    if (hasAnyRole([UserTypes.QualityAssuranceLead, UserTypes.QualityAssuranceCoordinator]))
        return <QualityAssuranceDashboard />;

    if (hasAnyRole([UserTypes.RecoveryLead, UserTypes.RecoveryCoordinator, UserTypes.Biobank, UserTypes.CEBT]))
        return <RecoveryDashboard />;

    if (hasRole(UserTypes.Invoicing) && hasPermission(Claims.ViewInvoice)) return <InvoicingDashboard />;

    if (hasAnyRole([UserTypes.SurgeryScheduler, UserTypes.Surgeon]) && hasPermission(Claims.ViewSurgery))
        return <SurgeryDashboard />;

    return (
        <Container>
            <h1>Dashboard</h1>
        </Container>
    );
}
